import { aboutData } from '@/mocks/about';

export default function Reputation() {
  return (
    <section className="mb-14">
      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
        品牌口碑
      </h2>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 mb-10">
        {aboutData.stats.map((stat) => (
          <div
            key={stat.label}
            className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 text-center"
          >
            <div className="text-2xl md:text-3xl font-bold text-primary-600 mb-1.5">{stat.value}</div>
            <div className="text-xs md:text-sm text-foreground-600">{stat.label}</div>
          </div>
        ))}
      </div>

      <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-5 text-center">
        发展历程
      </h3>
      <div className="relative">
        <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300/80 transform md:-translate-x-px hidden md:block"></div>
        <div className="space-y-6">
          {aboutData.milestones.map((milestone, index) => (
            <div
              key={milestone.year}
              className={`relative flex flex-col md:flex-row gap-4 ${
                index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              }`}
            >
              <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right md:pr-10' : 'md:text-left md:pl-10'}`}>
                <div className="hidden md:block">
                  <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-accent-100 text-accent-700 mb-1.5">
                    {milestone.year}
                  </span>
                  <p className="text-sm text-foreground-700">{milestone.event}</p>
                </div>
                <div className="md:hidden flex items-start gap-3">
                  <div className="w-3 h-3 mt-1.5 rounded-full bg-accent-500 flex-shrink-0"></div>
                  <div>
                    <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold bg-accent-100 text-accent-700 mb-1.5">
                      {milestone.year}
                    </span>
                    <p className="text-sm text-foreground-700">{milestone.event}</p>
                  </div>
                </div>
              </div>
              <div className="hidden md:flex items-center justify-center w-8 flex-shrink-0">
                <div className="w-3 h-3 rounded-full bg-accent-500"></div>
              </div>
              <div className="flex-1 hidden md:block"></div>
            </div>
          ))}
        </div>
      </div>

      <h3 className="text-lg font-heading font-semibold text-foreground-950 mt-12 mb-5 text-center">
        核心价值观
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {aboutData.values.map((v) => (
          <div
            key={v.title}
            className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center"
          >
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-2">{v.title}</h4>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{v.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}